export default __webpack_public_path__ + "static/media/mark_1.1d9de6fc.png";